import { filter, isArray, map, size, some, uniqBy } from "lodash";
import { Person } from "@/services";
import { UsersOnboardingStatuses } from "@/pages/requests/components/users/constants";

interface UsersOnboardingStatusesIssetType extends Partial<Person> {
  Value: string;
  Id: number;
  WorkerOnboardingStatus: number;
}

const defaultFilterValue = "Value"; // TODO clarify the type of this variable

export const prepareFilterOptions = (
  options: Person[],
  key: string,
  id: string,
): Person[] => {
  const transformedOptions = map(options, option => {
    return {
      ...option,
      Value: `${option[key as keyof Person]}` || "",
      Id: Number(option[id as keyof Person]),
    };
  });

  return filter(
    uniqBy(transformedOptions, defaultFilterValue),
    option => !!size(option[defaultFilterValue]),
  );
};

export const prepareStatusFilterOptions = (options: Person[]) => {
  const UsersOnboardingStatusesIsset: UsersOnboardingStatusesIssetType[] = [];

  if (isArray(options)) {
    options.forEach(item => {
      const status = item.WorkerOnboardingStatus;

      if (
        !some(
          UsersOnboardingStatusesIsset,
          option =>
            option[defaultFilterValue] === UsersOnboardingStatuses[status],
        )
      ) {
        UsersOnboardingStatusesIsset.push({
          Value: UsersOnboardingStatuses[status],
          Id: status,
          WorkerOnboardingStatus: status,
        });
      }
    });
  }

  return uniqBy(UsersOnboardingStatusesIsset, defaultFilterValue);
};

export const prepeareUserDate = (user: Person) => {
  return {
    ...user,
    isDisabled: user.WorkerOnboardingStatus === 0,
  };
};

export const getWorkerOnboardingStatus = (
  WorkerOnboardingStatus: number,
): string => {
  return UsersOnboardingStatuses[WorkerOnboardingStatus];
};

export const splitBracketedComments = (raw?: string): string[] => {
  if (!raw) {
    return [];
  }

  const result: string[] = [];
  const regexp = /\[([^\]]+)\]/g;
  let lastIndex = 0;
  let match: RegExpExecArray | null;

  while ((match = regexp.exec(raw)) !== null) {
    if (match.index > lastIndex) {
      const outside = raw.slice(lastIndex, match.index).trim();

      if (outside) {
        result.push(outside);
      }
    }

    const inner = match[1].trim();

    if (inner) {
      result.push(inner);
    }

    lastIndex = regexp.lastIndex;
  }

  if (lastIndex < raw.length) {
    const tail = raw.slice(lastIndex).trim();

    if (tail) {
      result.push(tail);
    }
  }

  if (!result.length) {
    return [raw];
  }

  return result;
};
